import script from "./lockscreenOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./lockscreenOverlay.vue?vue&type=script&setup=true&lang=js"

import "./lockscreenOverlay.vue?vue&type=style&index=0&id=4ce85813&scoped=true&lang=css"
import "./lockscreenOverlay.vue?vue&type=style&index=1&id=4ce85813&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ce85813"]])

export default __exports__